/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { clubMembershipSkipShipmentInput } from '../../../dataActions/DataActionExtension.g';
import { IrsmClubMembershipSkipShipmentResponse } from '../../../dataActions/DataServiceEntities.g';

/**
 * GetMembership Input Action
 */
export class WineShipmentStateInput implements Msdyn365.IActionInput {
    public input: IDataServiceRequest;
    constructor(input: IDataServiceRequest) {
        this.input = input;
    }

    public shouldCacheOutput = () => false;

    public getCacheKey = () => `IWineShipmentStateInput`;
    public getCacheObjectType = () => 'IWineShipmentStateInput';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IWineShipmentStateInput extends IrsmClubMembershipSkipShipmentResponse { }

export interface IInputRequirements {
    wineClubId: string;
    skipShipment: boolean;
}

export const createWineShipmentStateInput = (
    args: Msdyn365.ICreateActionContext,
    { skipShipment, wineClubId }: IInputRequirements,
): WineShipmentStateInput => {
    const accNumber = args.requestContext.user.customerAccountNumber;
    return new WineShipmentStateInput(
        clubMembershipSkipShipmentInput(
            accNumber!,
            wineClubId,
            skipShipment
        )
    );
};

export async function getWineShipmentStateAction(
    input: WineShipmentStateInput,
    ctx: Msdyn365.IActionContext,
): Promise<IWineShipmentStateInput> {
    return input.input.execute(ctx);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IWineShipmentStateInput>>getWineShipmentStateAction,
    input: createWineShipmentStateInput,
});
